import React, { useState, useEffect } from "react";
import { User } from "./requests";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Navigation from "./components/Navigation";
import SignInPage from "./components/SignInPage";
import AuthRoutes from "./components/AuthRoutes";
import ClientIndexPage from "./components/ClientIndexPage";
import ClientShowPage from "./components/ClientShowPage";
import NewClientPage from "./components/NewClientPage";
import EditClientPage from "./components/EditClientPage";
import EditBabyPage from "./components/EditBabyPage";
import EditCohabitantPage from "./components/EditCohabitantPage";
import NotFoundPage from "./components/NotFoundPage";
import Footer from "./components/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import { pickUp } from "./requests";

function App() {

  const [user, setUser] = useState(null);

  useEffect(() => {
    getCurrentUser();
  }, []);
  
  const getCurrentUser = () => {
    return User.current().then((user) => {
      if (user?.id) {
        setUser(user);
        getTodaysPickUps()
      }
    });
  };

  const onSignOut = () => {
    setUser(null);
  };

  const [pickUps, setPickUps] = useState([])

  const getTodaysPickUps = () => {
    return pickUp.today().then((pickUpsData) => {
      setPickUps(pickUpsData)
    })
  }

  return (
    <>
      <div className="position-relative min-vh-100 ">
        <Navigation currentUser={user} onSignOut={onSignOut} pickUps={pickUps} />
        <div className="pb-4 d-flex justify-content-center">
          <Routes>
            <Route
              path="/"
              element={<SignInPage onSignIn={getCurrentUser} />}
            />
            <Route element={<AuthRoutes isAuthenticated={!!user} />}>
              <Route
                path="/clients"
                element={<ClientIndexPage currentUser={user} />}
              />
              <Route
                path="/clients/:id"
                element={<ClientShowPage currentUser={user} getTodaysPickUps={getTodaysPickUps}  />}
              />
            </Route>
            <Route element={<AuthRoutes isAuthenticated={user?.admin} />}>
              <Route path="/clients/new" element={<NewClientPage />} />
              <Route path="/clients/:id/edit" element={<EditClientPage />} />
              <Route path="/babies/:id/edit" element={<EditBabyPage />} />
              <Route
                path="/cohabitants/:id/edit"
                element={<EditCohabitantPage />}
              />
            </Route>

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default App;
